// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/radio/index.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Primary} from './Primary.story';
import {Disabled} from './Disabled.story';
import {Uncontrolled} from './Uncontrolled.story';
import {Invalid} from './Invalid.story';

const basic = {
  rendered: <Primary />,
  source: `<Radio label="This is a Radio." />`,
};
const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<Radio
  name="group"
  label="Have some of Column A"
  onChange={(e) => {
    console.log(e.target.checked);
  }}
/>
<Radio
  name="group"
  label="Try all of Column B"
  onChange={(e) => {
    console.log(e.target.checked);
  }}
/>`,
};
const invalid = {
  rendered: <Invalid />,
  source: `<Radio label="This is an invalid input" invalid />`,
};
const disabled = {
  rendered: <Disabled />,
  source: `<Radio name="group" label="Ah ah ah" disabled />
<Radio
  name="group"
  disabled
  defaultChecked
  label="You didn't say the magic word"
/>`,
};
export const RadioExamples = {
  basic,
  uncontrolled,
  invalid,
  disabled,
};
